<mat-card appearance="outlined" class="ai-card map-layer-card">
  <app-card-header [displayName]="displayName()" [rawName]="data().label">
    <app-type-chip type="geojson" />
  </app-card-header>

  @if (data().ref; as r) {
  <app-file-block-card
    [ref]="r"
    kind="map_layer"
    [metadata]="data().metadata"
    [embedded]="true"
    [block]="data()"
    [addLayerLabel]="ctaLabel()"
  />
  }

  <!-- One chips row: the S3 metadata summary + the inline style preview (no fetch). -->
  @if (featureCount() !== null || bboxPresent() || contentSummary() !== null || styleLabel() || styleAuthorLabel()) {
  <div class="px-3 pb-2 d-flex flex-wrap gap-1 map-layer-card__chips">
    @if (featureCount() !== null) {
    <mat-chip>{{ featureCount() }} features</mat-chip>
    }
    @if (bboxPresent()) {
    <app-type-chip type="count" label="BBOX" />
    }
    @if (contentSummary(); as summary) {
    <mat-chip>{{ summary }}</mat-chip>
    }
    @if (styleLabel(); as label) {
    <app-type-chip type="count" [label]="label" class="map-layer-card__style-chip" />
    }
    @if (styleAuthorLabel(); as author) {
    <app-type-chip type="count" [label]="author" class="map-layer-card__style-chip" />
    }
  </div>
  }

  <app-block-debug-meta kind="map_layer" [data]="data()" />
</mat-card>
